<template>
    <footer class="footer">
      <div class="iconFooter">
        <ul class="iconFooter__ul fullContainer d-flex">
           <!-- <li class="iconFooter__li iconFooter__li iconFooter__li--active iconFooter__li--badge"><span class="iconFooter__iconWrapper iconFooter__iconWrapper--home"><img class="iconFooter__icon" src="@/assets/img/main/footer_btn_01.png" alt=""/><img class="iconFooter__icon" src="@/assets/img/main/footer_btn_01_on.png" alt=""/></span><span class="iconFooter__text">ホーム</span> -->

          <li :class="iconFooter__li_class('/teaser')">
            <a class="iconFooter__link" :href="go_teaser">
              <!-- <span class="iconFooter__iconWrapper iconFooter__iconWrapper--home">
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_01.png" alt=""/>
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_01_on.png" alt=""/>
              </span> -->
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-house"></i>
              </span>
              <span class="iconFooter__text">{{ word_chg('ホーム')}}</span>
            </a>
          </li>
          <li :class="iconFooter__li_class('/')">
            <router-link class="iconFooter__link" to="/">
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-calendar"></i>
              </span>
              <span class="iconFooter__text">{{ word_chg('カレンダー')}}</span>
            </router-link>
          </li>
          <li :class="iconFooter__li_class('/reservation/')">
            <router-link class="iconFooter__link" to="/reservation/drive">
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-pencil-square"></i>
              </span>
              <!-- <span class="iconFooter__iconWrapper iconFooter__iconWrapper--calendar">
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_02.png" alt=""/>
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_02_on.png" alt=""/>
              </span> -->
              <span class="iconFooter__text">{{ word_chg('予約')}}</span>
            </router-link>
          </li>
          <li :class="iconFooter__li_class('/information/')">
            <router-link class="iconFooter__link" to="/information/list">
              <!-- <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_04.png" alt=""/>
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_04_on.png" alt=""/>
              </span> -->
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-chat-fill"></i>
              </span>
              <span class="iconFooter__text">{{ word_chg('お知らせ')}}</span>
            </router-link>
          </li>
          <li :class="iconFooter__li_class('/event/')" v-if="vue_node_env != 'production'">
            <router-link class="iconFooter__link" to="/event/list">
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-star"></i>
              </span>
              <span class="iconFooter__text">{{ word_chg('イベント')}}</span>
            </router-link>
          </li>
          <li :class="iconFooter__li_class('/user/')">
            <router-link class="iconFooter__link" to="/user/index">
              <!-- <span class="iconFooter__iconWrapper iconFooter__iconWrapper--member">
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_05.png" alt=""/>
                <img class="iconFooter__icon" src="@/assets/img/main/footer_btn_05_on.png" alt=""/>
              </span> -->
              <span class="iconFooter__iconWrapper iconFooter__iconWrapper--information">
                <i class="bi bi-person-badge-fill"></i>
              </span>
              <span class="iconFooter__text">{{ word_chg('会員証')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </footer>
</template>
<style scoped>
    footer {
        clear: both;
        box-shadow: inset 0 1px 0 rgb(0 0 0 / 10%) !important;
    }
    .footer_link_txt {
        font-size: 80%;
        display: block;
    }
    a {
        text-decoration: none;
    }
</style>

<script>
  export default {
    name: 'BsFooterView',
    data: function () {
        return {
            // 'tab_active': 'drive',//or th ead
        }
    },
    props: {
    },
    components: {
        // BsPageTitle,
    },
    methods: {
    },
    computed: {
      go_teaser: function(){
        if(
          this.app_lang_type == 'ja'
        ){
          return '/mgcweb/mgwapp/teaser/index.html';
        }
        else{
          return '/mgcweb/mgwapp/teaser/en.html';
        }
      },
      app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
      },
      iconFooter__li_class: function(){
        const fromPath = this.$route.path;
        return function (toPath){
          let classParam = 'iconFooter__li';
          if(
            fromPath == toPath
            ||
            (fromPath.startsWith(toPath) && toPath != '/')
          ){
            classParam += ' iconFooter__li--active iconFooter--badge';
          }
          return classParam;
        }
      },
    },
  }
</script>
